// The words a text model's speech recognition listens for (config.vocabulary, 2026-10-20; shared/agent-models.json,
// which vocabulary.test.ts holds this file to). The assistant function refuses a list out of these bounds.
export const VOCABULARY_MAX_TERMS = 100;
export const VOCABULARY_MAX_CHARS = 60;

export const VOCABULARY_HELP =
  "Brand, product and place names your callers say, one per line, so that speech recognition hears them right " +
  `(up to ${VOCABULARY_MAX_TERMS}, ${VOCABULARY_MAX_CHARS} characters each).`;

/** The box's words: one per line, trimmed, blanks and repeats dropped, as the assistant function keeps them. */
export const vocabularyTerms = (text: string): string[] => [
  ...new Set(
    text
      .split("\n")
      .map((term) => term.trim())
      .filter(Boolean),
  ),
];

/** A stored config.vocabulary as the box shows it. */
export const vocabularyText = (stored: unknown): string =>
  Array.isArray(stored) ? stored.filter((term): term is string => typeof term === "string").join("\n") : "";

/** Why the assistant function would refuse these words, in the customer's words, or null. */
export function vocabularyError(terms: string[]): string | null {
  if (terms.length > VOCABULARY_MAX_TERMS) {
    return `Keep it to ${VOCABULARY_MAX_TERMS} words or phrases: there are ${terms.length}.`;
  }
  const long = terms.find((term) => term.length > VOCABULARY_MAX_CHARS);
  return long === undefined ? null : `"${long}" is longer than ${VOCABULARY_MAX_CHARS} characters.`;
}
